<template>
  <!-- NOTE: white-space: pre-wrap;を指定している要素はDOM上の改行と空白もレンダリングしてしまうため、
  このファイルではそのeslintルールを除外している -->
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <!-- eslint-disable vue/multiline-html-element-content-newline -->
  <div class="ticket--for_term_of_sales">
    <div class="ticket-box">
      <div class="ticket-info">
        <span class="ticket__brand">{{ brandName }}</span>
        <span class="ticket__item-name">{{ itemName }}</span>
        <span v-if="isNotEmptyItemSkuName" class="ticket__item-min-unit">{{
          itemSkuName
        }}</span>
        <span class="ticket__item-price">
          ¥{{ price.toLocaleString() }}{{ displayIncludingTax }}
        </span>
        <span class="ticket__count">数量：{{ ticketCount }} 枚</span>
        <span class="ticket__offer-time">
          引渡/提供時期：{{ displayOfferTime }}
        </span>
        <span class="ticket__sales-period">
          申込期間：{{ displaySalesPeriod }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    isDeliveryItem: {
      type: Boolean,
      required: true
    },
    ticketCount: {
      type: Number,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    limitedTimeSalesEndedAt: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    isNotEmptyItemSkuName() {
      return this.itemSkuName !== ''
    },
    displayIncludingTax() {
      return this.isIncludingTax ? '（税込）' : ''
    },
    displayOfferTime() {
      return this.isDeliveryItem
        ? '配送は各ブランドの責任により行いますが、受取人様において発送先住所入力をいただいてから7日以内を目安にブランド側にて発送いたします。'
        : '電子チケットについては、決済完了後、即時に発行いたします。'
    },
    isLimitedTimeSales() {
      return dayjs(this.limitedTimeSalesEndedAt).isValid()
    },
    formattedLimitedTimeSalesEndedAt() {
      return dayjs(this.limitedTimeSalesEndedAt).format('YYYY年MM月DD日 HH:mm')
    },
    displaySalesPeriod() {
      return this.isLimitedTimeSales
        ? `${this.formattedLimitedTimeSalesEndedAt}までの期間限定販売`
        : '期間制限なし'
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  &-box {
    height: auto;
    max-width: 375px;
    margin: 0 auto;
    display: flex;
  }

  &-info {
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__item-name {
    @extend %text-bold;
  }

  &__item-min-unit {
    @extend %text-bold;
  }

  &__brand {
    @extend %text-bold;
  }

  &__item-price {
    @extend %text;
  }

  &__count {
    @extend %text;
  }

  &__offer-time {
    @extend %text;
  }

  &__sales-period {
    @extend %text;
  }
}
%text-bold {
  @extend %caption-bold;
  color: $black;
}
%text {
  @extend %caption-black;
}
</style>
